import { Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import BusinessPostule from './Components/BusinessPostule';
import SchoolPostule from './Components/SchoolPostule';

const Candidatures = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const location = useLocation();

  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (
      location?.state?.from === 'offreSave' ||
      location?.state?.from === 'offrePostule'
    ) {
      setValue('1');
    }
    if (
      location?.state?.from === 'formationSave' ||
      location?.state?.from === 'formationPostule'
    ) {
      setValue('2');
    } else {
      setValue('1');
    }
  }, []);

  const [emploiLength, setEmploiLength] = useState(0);
  const [formationLength, setFormationLength] = useState(0);

  const handleEmploiLength = (length) => {
    setEmploiLength(length);
  };

  const handleFormationLength = (length) => {
    setFormationLength(length);
  };

  return (
    <div className={cx(global.container, classes.container)}>
      <div className={classes.paper} square>
        <TabContext value={value}>
          <TabList indicatorColor="default" onChange={handleChange}>
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  '@media only screen and (max-width:768px)': { width: '50%' },
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={`Emplois`}
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  '@media only screen and (max-width:768px)': { width: '50%' },
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={`Formations`}
              value="2"
            />
          </TabList>
          <div>
            <TabPanel
              className={css({
                background: 'white',
                borderRadius: '0 10px 10px 10px',
                padding: spacing(2.5),
                '@media only screen and (max-width:768px)': {
                  borderRadius: '0 0px 10px 10px',
                },
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
              value="1"
            >
              <BusinessPostule handleEmploiLength={handleEmploiLength} />
            </TabPanel>
            <TabPanel
              className={css({
                background: 'white',
                borderRadius: '0 10px 10px 10px',
                padding: spacing(2.5),
                '@media only screen and (max-width:768px)': {
                  borderRadius: '0 0px 10px 10px',
                },
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
              value="2"
            >
              <SchoolPostule handleFormationLength={handleFormationLength} />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '110%',
  },
  paper: {
    borderRadius: 10,

    // background,
  },
});

export default Candidatures;
